export default "__VITE_ASSET__DLYu0TWt__"